import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {
  savedSampleOfOrderDetails: any = {
    connection_name: '',
    type_of_good: 'digital-goods',
    origin_country: 'India',
    importer_name: '',
    country_code: 'IN',
    address_1: '',
    address_2: '',
    gateway_type: '',
    city: '',
    postal_code: ''
  };
  constructor() { }

  getStatus(rowData) {
    if (+rowData.wa_status === 1) {
      return {
        status: 'Approved',
        tooltip: ''
      };
    } else if (+rowData.wa_status === 0) {
      if (rowData.status && +rowData.status === 2) {
        return {
          status: 'Draft',
          tooltip: ''
        };
      } else if (rowData.status && +rowData.status === 1) {
        return {
          status: 'Pending',
          tooltip: 'The template is sent to Meta For Approval.'
        };
      }
      else {
        return {
          status: 'Rejected',
          tooltip: 'The template is rejected by Meta. You can edit and resubmit for approval.'
        };
      }
    } else if (+rowData.wa_status === 2) {
      return {
        status: 'Rejected',
        tooltip: 'The template is rejected by Meta. You can edit and resubmit for approval.'
      };
    } else if (+rowData.wa_status === 3) {
      return {
        status: 'Appeal',
        tooltip: ""
      };
    } else if (+rowData.wa_status === 4) {
      return {
        status: 'Disabled',
        tooltip: ""
      };
    } else if (+rowData.wa_status === 5) {
      return {
        status: 'Flagged',
        tooltip: ""
      };
    } else if (+rowData.wa_status === 6) {
      return {
        status: 'Reinstated',
        tooltip: ""
      };
    } else if (+rowData.wa_status === 7) {
      return {
        status: 'Paused',
        tooltip: ""
      };
    } else if (+rowData.wa_status === 8) {
      return {
        status: 'Deletion',
        tooltip: ""
      };
    }
  }

  /**
   * @param htmlText HTML string to convert into WhatsApp format
   * @returns string with WhatsApp supported format
   *
   * RegExp explaination:
   *  ^(\s*)(?=\S):
      ^: Anchors the match at the beginning of the string.
      (\s*): Captures any leading whitespace characters.
      (?=\S): Positive lookahead to ensure that the whitespace is followed by a non-whitespace character.

      (?<=\S)(\s*)$:
      (?<=\S): Positive lookbehind to ensure that the trailing whitespace is preceded by a non-whitespace character.
      (\s*)$: Captures any trailing whitespace characters before the end of the string.


      The regex ensures that the formatting symbols are correctly placed around the content, preserving any leading or trailing whitespace but still wrapping the non-whitespace content with the formatting codes.

      For an HTML like <strong> Hello </strong>, the method will convert it to * Hello *, ensuring that the asterisks are placed correctly around the content, even if there are leading or trailing spaces.
   */
  getWhatsAppFormattedText(htmlText) {
    const formatCodes = {
      STRONG: "*",
      EM: "_",
      DEL: "~",
      FONT: "```"
    };
    // extract body of the html
    const { body } = new DOMParser().parseFromString(htmlText, "text/html");
    // extract childNodes of the body
    const dfs = ({ childNodes }) => Array.from(childNodes, (node: any) => {
      // if child node is an element like div, span, strong etc..
      if (node.nodeType === 1) {
        const text = dfs(node);
        const code = formatCodes[node.tagName];
        if (code) {
          // wrap text with respective format
          return text.replace(/^(\s*)(?=\S)|(?<=\S)(\s*)$/g, `$1${code}$2`);
        }
        return text;
      }
      return node.textContent;
    }).join("");
    return dfs(body);
  }

  // converts WhatsApp formatted string to an HTML string
  getFormattedHTMLOfWhatsAppText(whatsAppFormatText) {
    const formatMap = [
      { code: /\*(.*?)\*/gs, tag: "strong", className: "bold" },
      { code: /_(.*?)_/gs, tag: "em", className: "italic" },
      { code: /~(.*?)~/gs, tag: "del", className: "strikethrough" },
      { code: /```(.*?)```/gs, tag: "font", className: "monospace-font" }
    ];

    let htmlText = whatsAppFormatText;
    formatMap.forEach(({ code, tag, className }) => {
      // replace nested format code
      while (code.test(htmlText)) {
        htmlText = htmlText.replace(code, `<${tag} class="${className}">$1</${tag}>`);
      }
    });
    return htmlText;
  }


  // sets icon to each button based on button type
  setIconClass(buttonData:any[]) {
    buttonData = buttonData.map((singleBtn) => {
      switch (singleBtn.button) {
        case "MarketingOptOut":
          singleBtn.iconClass = "nxticon-open-link nxt-font-15";
          singleBtn.btn_text = "Stop promotions"
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#6F6F8D'
          break;
        case "Custom":
          singleBtn.iconClass = "nxticon-open-link nxt-font-15";
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#6F6F8D'
          break;
        case "VisitWebsite":
          singleBtn.iconClass = "nxticon-visit nxt-font-16";
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#0A8FFD'
          break;
        case "CallPhoneNumber":
          singleBtn.iconClass = "nxticon-phone nxt-font-16";
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#0A8FFD'
          break;
        case "CopyOfferCode":
          singleBtn.iconClass = "nxticon-copy-outline nxt-font-16";
          singleBtn.btn_text = "Copy offer code"
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#0A8FFD'
          break;
        case "Flow":
          singleBtn.iconClass = "nxticon-flow-button nxt-font-16";
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#0A8FFD'
          break;
        default:
          singleBtn.iconClass = "";
          singleBtn.color1 = '#0A8FFD'
          singleBtn.color2 = '#0A8FFD'
          singleBtn.btn_text = ""
          break;
      }
      return singleBtn;
    });
    return buttonData;
  }

  // function to return formatted/parsed sample data.
  setSampleData(templateType,sample){
    let sampleData:any = {};
    sampleData.templateType = templateType;
    if (templateType === 'catalogue') {
      sampleData.thumbnail_product_retailer_id = sample?.components[0]?.example[0]?.thumbnail_product_retailer_id ? sample.components[0].example[0].thumbnail_product_retailer_id : '';
    } else if (templateType === 'multi-product') {
      sampleData.header_variables_count = sample?.components[0]?.header_variables_count ? sample.components[0].header_variables_count : 0;
      sampleData.thumbnail_product_retailer_id = sample?.components[3]?.example[0]?.thumbnail_product_retailer_id ? sample.components[3].example[0].thumbnail_product_retailer_id : '';
      sampleData.multi_product_title1 = sample?.components[3]?.example[1]?.multi_product_title1 ? sample.components[3].example[1].multi_product_title1 : '';
      sampleData.multi_product1_id1 = sample?.components[3]?.example[2]?.multi_product1_id1 ? sample.components[3].example[2].multi_product1_id1 : '';
      sampleData.multi_product1_id2 = sample?.components[3]?.example[3]?.multi_product1_id2 ? sample.components[3].example[3].multi_product1_id2 : '';
      sampleData.multi_product_title2 = sample?.components[3]?.example[4]?.multi_product_title2 ? sample.components[3].example[4].multi_product_title2 : '';
      sampleData.multi_product2_id1 = sample?.components[3]?.example[5]?.multi_product2_id1 ? sample.components[3].example[5].multi_product2_id1 : '';
      sampleData.multi_product2_id2 = sample?.components[3]?.example[6]?.multi_product2_id2 ? sample.components[3].example[6].multi_product2_id2 : '';
      sampleData.default_header_var = sample?.components[0]?.example[0]?.default_header_var ? sample.components[0].example[0].default_header_var : '';
    } else if (templateType === 'media') {
      sampleData.upload_type = sample?.components[0]?.upload_type ? sample.components[0].upload_type : '2';
      sampleData.fileType = sample?.components[0]?.fileType ? sample.components[0].fileType : '2';
      sampleData.url = sample?.components[0]?.example[0]?.url ? sample.components[0].example[0].url : '';
      sampleData.sampleId = sample?.components[0]?.example[0]?.sampleId ? sample.components[0].example[0].sampleId : ''
    } else if (templateType === 'text') {
      sampleData.header_variables_count = sample?.components[0]?.header_variables_count ? sample.components[0].header_variables_count : 0;
      sampleData.default_header_var = sample?.components[0]?.example[0]?.default_header_var ? sample.components[0].example[0].default_header_var : '';
    } else if (templateType === 'order_details') {
      sampleData.upload_type = sample?.components[0]?.upload_type ? sample.components[0].upload_type : '2';
      sampleData.fileType = sample?.components[0]?.fileType ? sample.components[0].fileType : '2';
      sampleData.url = sample?.components[0]?.example[0]?.url ? sample.components[0].example[0].url : '';
      sampleData.sampleId = sample?.components[0]?.example[0]?.sampleId ? sample.components[0].example[0].sampleId : '';
      // offset value is fixed for INR currency. Refer Meta docs for more info
      const OFFSET = 100;
      const order_details = sample?.components[4]?.example[0];
      const order = order_details?.order;
      const item0 = order?.items && order?.items[0] ? order.items[0] : {};
      const importer_address = item0?.importer_address;
      const amount = item0?.amount;
      const connection_name = order_details?.payment_settings ? order_details.payment_settings[0]?.payment_gateway?.configuration_name : '';
      const payment_gateway = order_details?.payment_settings ? order_details.payment_settings[0]?.payment_gateway?.title : '';
      sampleData.order_details = {
        connection_name: connection_name ? connection_name : '',
        payment_gateway: payment_gateway ? payment_gateway : '',
        reference_id: order_details?.reference_id ? order_details.reference_id : '',
        type_of_good: order_details?.type ? order_details.type : '',
        origin_country: item0?.country_of_origin ? item0.country_of_origin : '',
        importer_name: item0?.importer_name ? item0.importer_name : '',
        address_1: importer_address?.address_line1 ? importer_address.address_line1 : '',
        address_2: importer_address?.address_line2 ? importer_address.address_line2 : '',
        city: importer_address?.city ? importer_address.city : '',
        country_code: importer_address?.country_code ? importer_address.country_code : '',
        postal_code: importer_address?.postal_code ? importer_address.postal_code : '',
        amount: amount?.value ? parseInt(amount.value, 10) / OFFSET : 0,
        quantity: item0?.quantity ? parseInt(item0.quantity, 10) : 0,
        discount: order?.discount?.value ? parseInt(order.discount.value, 10) / OFFSET : 0,
        tax: order?.tax?.value ? parseInt(order.tax.value, 10) / OFFSET : 0,
        shipping: order?.shipping?.value ? parseInt(order.shipping.value, 10) / OFFSET : 0,
        product_name: item0?.name ? item0.name : '',
        product_id: item0?.retailer_id ? item0.retailer_id : ''
      };
    } else if (templateType === 'order_status') {
      const order_status = sample?.components[4]?.example[0];
      sampleData.order_status = {
        reference_id: order_status?.reference_id ? order_status.reference_id : '',
        status: order_status?.status ? order_status.status : '',
        description: order_status?.description ? order_status.description : ''
      };
    }
    if (sample?.components[2] && sample?.components[2]?.isBtn){
      sampleData.test_dynamic_url_1 = sample?.components[2]?.test_dynamic_url_1;
      sampleData.test_dynamic_url_2 = sample?.components[2]?.test_dynamic_url_2;
      sampleData.test_dynamic_part_url_1 = sample?.components[2]?.test_dynamic_part_url_1;
      sampleData.test_dynamic_part_url_2 = sample?.components[2]?.test_dynamic_part_url_2;
      sampleData.copy_code_val = sample?.components[2]?.copy_code_val;
    }
    if (sample?.components[1]?.body_variables_count) {
      sampleData.body_variables_count = sample?.components[1]?.body_variables_count;
      for (let i = 0; i < sampleData.body_variables_count; i++) {
        let key = `default_body_var_${(i + 1)}`;
        if (sample.components[1]?.example[i] && sample.components[1]?.example[i][key]){
          sampleData[key] = sample.components[1]?.example[i][key] ? sample.components[1].example[i][key] : '';
        }
      }
    }
    return sampleData;
  }

  setCarouselSampleData(sample,templateDetailData){
    let withTracking = [];
    let withoutTracking = [];
    let carousalSampleData = {
      'text':  templateDetailData.text,
      'messageBubble_variables' : '',
      'cards': []
    }
    carousalSampleData.messageBubble_variables = templateDetailData.messageBubble_variables;
    for (let i = 0; i < templateDetailData.messageBubble_variables; i++) {
      carousalSampleData[`default_bubble_var_${i + 1}`] = templateDetailData.body_example ? templateDetailData.body_example[i] ? templateDetailData.body_example[i][`default_bubble_var_${(i + 1)}`] ? templateDetailData.body_example[i][`default_bubble_var_${(i + 1)}`] : '' : '' : ''
    }
    for (let i = 0; i <  templateDetailData.cards.length; i++) {
       carousalSampleData[`cards`].push([]);
    }
    for (let i = 0; i <  templateDetailData.cards.length; i++) {
       carousalSampleData['cards'][i]['swap'] =  templateDetailData.cards[i].swap;
       carousalSampleData['cards'][i]['upload_type'] =  templateDetailData.cards[i].upload_type;
       carousalSampleData['cards'][i]['template_header'] =  templateDetailData.cards[i].format;
       carousalSampleData['cards'][i]['url'] =  sample ? sample[1].cards[i].components[0].example[0].url ? sample[1].cards[i].components[0].example[0].url : '' : '';
       carousalSampleData['cards'][i]['sampleId'] =  sample ? sample[1].cards[i].components[0].example[0].sampleId ? sample[1].cards[i].components[0].example[0].sampleId : '' : '';
       carousalSampleData['cards'][i]['image_file'] =  templateDetailData.cards[i]?.image_file ?  templateDetailData.cards[i]?.image_file : '';
       carousalSampleData['cards'][i]['fileType'] =  templateDetailData.cards[i]?.fileType ?  templateDetailData.cards[i]?.fileType : '';
       carousalSampleData['cards'][i]['imageSrc'] =  templateDetailData.cards[i]?.imageSrc ?  templateDetailData.cards[i]?.imageSrc : '';
       carousalSampleData['cards'][i]['text'] =  templateDetailData.cards[i]?.text ?  templateDetailData.cards[i]?.text : '';
       carousalSampleData['cards'][i]['template_content_variables'] =  templateDetailData.cards[i]?.template_content_variables ?  templateDetailData.cards[i].template_content_variables : '';
      for (let k = 0; k <  templateDetailData.cards[i].template_content_variables; k++) {
         carousalSampleData['cards'][i][`default_body_var_${k + 1}`] =  templateDetailData.cards[i]?.body_example ? templateDetailData.cards[i]?.body_example[k] ? templateDetailData.cards[i]?.body_example[k][`default_body_var_${(k + 1)}`] ?  templateDetailData.cards[i].body_example[k][`default_body_var_${(k + 1)}`] : '' : '' : '';
      }
       templateDetailData.cards[i].button_value.forEach((button: any) => {
        if (button.button === 'VisitWebsite' && button?.urlType === 'withTracking') {
           withTracking.push(button);
        } else if (button.button === 'VisitWebsite' && button?.urlType === 'withoutTracking') {
           withoutTracking.push(button);
        }
      })
       carousalSampleData['cards'][i]['cta_buttons'] =  templateDetailData.cards[i]?.cta_buttons ?  templateDetailData.cards[i].cta_buttons : '';
       carousalSampleData['cards'][i]['quick_replies'] =  templateDetailData.cards[i]?.quick_replies ?  templateDetailData.cards[i].quick_replies : '';
       carousalSampleData['cards'][i]['withTracking'] =  withTracking;
       carousalSampleData['cards'][i]['withoutTracking'] =  withoutTracking;
      if (carousalSampleData['cards'][i]['withTracking'].length > 0) {
        carousalSampleData['cards'][i]['test_dynamic_url_1'] = withTracking[0]?.example ? withTracking[0]?.example[0] ? withTracking[0]?.example[0]?.test_dynamic_url_1 ? withTracking[0].example[0].test_dynamic_url_1 : '' : '' : '';
        if (carousalSampleData['cards'][i]['withTracking'].length > 1) {
          carousalSampleData['cards'][i]['test_dynamic_url_2'] = withTracking[1]?.example ? withTracking[1]?.example[0] ? withTracking[1]?.example[0]?.test_dynamic_url_2 ? withTracking[1].example[0].test_dynamic_url_2 : '' : '' : '';
        }
      }
      if (carousalSampleData['cards'][i]['withoutTracking'].length > 0) {
        carousalSampleData['cards'][i]['test_dynamic_part_url_1'] = withoutTracking[0]?.example ? withoutTracking[0]?.example[0] ? withoutTracking[0]?.example[0]?.test_dynamic_part_url_1 ? withoutTracking[0].example[0].test_dynamic_part_url_1 : '' : '' : '';
        if (carousalSampleData['cards'][i]['withoutTracking'].length > 1) {
          carousalSampleData['cards'][i]['test_dynamic_part_url_2'] = withoutTracking[1]?.example ? withoutTracking[1]?.example[0] ? withoutTracking[1]?.example[0]?.test_dynamic_part_url_2 ? withoutTracking[1].example[0].test_dynamic_part_url_2 : '' : '' :'';
        }
      }
      withTracking = [];
      withoutTracking = [];
    }
    return carousalSampleData;
  }

  /**
   * @param sampleData Object
   * @returns Object
   * Refer: https://developers.facebook.com/docs/whatsapp/cloud-api/payments-api/payments-in/pg/
   * for payment related info
   */
  getPayloadOfOrderDetails(sampleData) {
    // offset value is fixed for INR currency. Refer Meta docs for more info
    const OFFSET = 100;
    const { order_details } = sampleData;
    let subTotal = 0;
    let total = 0;
    if (order_details?.amount && order_details?.quantity) {
      subTotal = order_details.amount * order_details.quantity;
      total = (subTotal + order_details.tax) - order_details.discount;
      if (order_details?.shipping) {
        total += order_details.shipping;
      }
    }
    let payload: any = {
      "currency": "INR",
      "order": {
        "discount": {
          "offset": OFFSET.toString(),
          "value": (order_details?.discount ? (order_details.discount * OFFSET) : 0).toString()
        },
        "items": [
          {
            "amount": {
              "offset": OFFSET.toString(),
              "value": (order_details?.amount ? (order_details.amount * OFFSET) : 0).toString()
            },
            "name": order_details?.product_name ? order_details.product_name : '',
            "quantity": (order_details?.quantity ? order_details.quantity : 0).toString(),
            // "retailer_id": order_details?.product_id ? order_details.product_id : '',
          }
        ],
        "shipping": {
          "offset": OFFSET.toString(),
          "value": (order_details?.shipping ? (order_details.shipping * OFFSET) : 0).toString()
        },
        "status": "pending",
        "subtotal": {
          "offset": OFFSET.toString(),
          "value": (subTotal * OFFSET).toString()
        },
        "tax": {
          "offset": OFFSET.toString(),
          "value": (order_details?.tax ? (order_details.tax * OFFSET) : 0).toString()
        }
      },
      "payment_settings": [{
        "type": "payment_gateway",
        "payment_gateway": {
          "type": order_details?.gateway_type,
          "configuration_name": order_details?.connection_name
        }
      }],
      "reference_id": order_details?.reference_id ? order_details.reference_id : '',
      "total_amount": {
        "offset": OFFSET.toString(),
        "value": (total * OFFSET).toString()
      },
      "type": order_details?.type_of_good ? order_details.type_of_good : ''
    };
    if (sampleData?.url) {
      payload.order.items[0].image = {
        "link": sampleData.url
      };
    }
    if (order_details?.type_of_good === 'physical-goods') {
      payload.order.items[0].country_of_origin = order_details?.origin_country ? order_details.origin_country : '';
      payload.order.items[0].importer_name = order_details?.importer_name ? order_details.importer_name : '';
      payload.order.items[0].importer_address = {
        "address_line1": order_details?.address_1 ? order_details.address_1 : '',
        "address_line2": order_details?.address_2 ? order_details.address_2 : '',
        "city": order_details?.city ? order_details.city : '',
        "country_code": order_details?.country_code ? order_details.country_code : '',
        "postal_code": order_details?.postal_code ? order_details.postal_code : ''
      }
    }
    return payload;
  }

  getPayloadOfOrderStatus(sampleData) {
    const { order_status } = sampleData;
    const payload = {
      "reference_id": order_status?.reference_id ? order_status.reference_id : '',
      "order": {
        "status": order_status?.status ? order_status.status : '',
        "description": order_status?.description ? order_status.description : ''
      }
    }
    return payload;
  }
}
